import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { RootState } from '../../../../reducers';
import SummaryEmpty from './SummaryEmpty';
import SummaryViewOnly from './summaryViewOnly';
import SummaryEditable from './SummaryEditable';

const Summary = () => {
  const { selectedVideo } = useSelector((state: RootState) => state);
  const { summary } = selectedVideo;
  const { text } = summary;
  const { isEditing } = summary;

  return (
    <Box sx={{ p: 1 }}>
      {!text && <SummaryEmpty />}
      {text && !isEditing && <SummaryViewOnly />}
      {text && isEditing && <SummaryEditable />}
    </Box>
  );
};

export default Summary;
